export const GET_SERVICES_LIST = null;
export const GET_SERVICES_SELECT_LIST = null;
export const SELECTED_SERVICE_ID = null;
export const GET_SERVICE_BY_ID = null;
export const GET_SERVICE_SELECT_LIST_BASED_ON_AVAILABILITY = null;
export const GET_STAFF_SELECT_LIST_BASED_ON_AVAILABILITY = null;
export const GET_USER_PROFILE_DETAILS = null;
